<div class="loading"><div class="container"> <div class="dot dot1"></div><div class="dot dot2"></div><div class="dot dot3"></div></div></div>